import { useMutation } from "urql";

import { ActivateLimitDocument } from "../../../graphql/generated.ts";

export const useActivateLimit = () => useMutation(ActivateLimitDocument);
